export const ACADEMY_MODULE_TYPES = {
  core: 'core',
  career: 'career',
  supplementary: 'supplementary',
};
